import React, { FC } from 'react';

type HintProps = {
  label?: string;
  icon?: string;
  type?: 'positive' | 'negative' | 'module-color' | 'warning';
  size?: string;
  clean?: boolean;
  className?: string;
};

const Hint: FC<HintProps> = ({
  label,
  icon = 'fa-times-circle',
  children,
  type = 'positive',
  size = 'md',
  clean = true,
  className = ''
}) => {
  return (
    <>
      {label && <label className="label">{label}</label>}
      <div
        className={`hint ${icon} ${type} ${size} ${
          clean ? 'clean' : ''
        } ${className}`}
      >
        <div className="hint-content">{children}</div>
      </div>
    </>
  );
};

export { Hint };
